import { POST } from "../../index";

export const queryLogList = (param) => POST("/v1/log/queryLogList", param);
